import { notification, signer, topNav } from "theme/colors";

// The 38px icon buttons and the 1px rules between groups, per the Inkfree
// Dashboard reference. Kept in their own module rather than in TopNav so the
// Inbox and Notification triggers can share them without importing their own
// parent (TopNav renders both, so that would be a cycle).
export const topNavIconButtonSx = {
  position: "relative",
  width: 38,
  height: 38,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color: topNav.icon,
  cursor: "pointer",
  // Reset the native <button> chrome so the trigger keeps its icon-tile look
  // when rendered as a real, keyboard-operable button.
  border: "none",
  background: "transparent",
  p: 0,
  transition: "background 0.15s",
  "&:hover": { backgroundColor: topNav.iconHoverBg },
  "&:focus-visible": {
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: "2px",
  },
} as const;

export const topNavDividerSx = {
  width: "1px",
  height: "26px",
  flexShrink: 0,
  backgroundColor: topNav.divider,
} as const;

// Usage & plan popover, sampled from the Inkfree reference. Same family as the
// dashboard tokens (#211547 heading / #9B96AE meta / #EFEDF5 track) — kept here
// because the popover hangs off the TopNav, not the dashboard.
export const planUsageRef = {
  heading: signer.ink, // plan name, "Sign requests"
  metaText: signer.text.faint, // overline, validity, footer note
  valueText: signer.text.meta, // "10 used · Unlimited"
  divider: signer.surface.muted,
  progressTrack: signer.border.light,
  progressFill: signer.orange.main,
  activeChipText: "#1E9E6A",
  activeChipBg: notification.success.bg,
  unlimitedChipText: signer.orange.main, // same orange as the meter fill
  unlimitedChipBg: signer.orange.hover,
  contentPadding: 20, // px — text inset; the divider is full-bleed past it
};

// Type scale from the reference (px → rem at a 16px root).
export const planUsageFont = {
  overline: "0.6875rem", // 11px  USAGE & PLAN
  chip: "0.6875rem", // 11px  ACTIVE
  planName: "1.25rem", // 20px  Standard
  validity: "0.8125rem", // 13px  Valid until 27 Aug 2026
  rowLabel: "0.84375rem", // 13.5px  Sign requests
  rowValue: "0.84375rem", // 13.5px  10 used · Unlimited
  note: "0.8125rem", // 13px  footer sentence
};

// Bar and pill geometry, in px, so the skeleton can reuse the same numbers.
export const planUsageSize = {
  barHeight: 7,
  chipHeight: 22,
  unlimitedChipHeight: 20, // "∞ Unlimited" pill shown instead of a meter
};
